import * as React from "react";
import { SVGProps } from "react";
export const DocPencilIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.5 18C5.08333 18 4.72933 17.854 4.438 17.562C4.146 17.2707 4 16.9167 4 16.5V3.5C4 3.08333 4.146 2.72933 4.438 2.438C4.72933 2.146 5.08333 2 5.5 2H11.375C11.5697 2 11.7573 2.03467 11.938 2.104C12.118 2.17333 12.2847 2.28467 12.438 2.438L15.562 5.562C15.7153 5.71533 15.8267 5.88233 15.896 6.063C15.9653 6.243 16 6.43033 16 6.625V10H14.5V7H11.75C11.542 7 11.365 6.927 11.219 6.781C11.073 6.635 11 6.458 11 6.25V3.5H5.5V16.5H10V18H5.5ZM15.354 12.021L16.104 12.75L12.5 16.292V17H13.208L16.812 13.438L17.5 14.125L13.854 17.771C13.7847 17.8403 13.705 17.896 13.615 17.938C13.5243 17.9793 13.4233 18 13.312 18H11.875C11.7777 18 11.691 17.9617 11.615 17.885C11.5383 17.809 11.5 17.7223 11.5 17.625V16.188C11.5 16.0767 11.5207 15.9757 11.562 15.885C11.604 15.795 11.6597 15.7153 11.729 15.646L15.354 12.021ZM17.5 14.125L15.354 12.021L16.583 10.792C16.7777 10.5973 17.014 10.4967 17.292 10.49C17.5693 10.4827 17.8053 10.5763 18 10.771L18.708 11.5C18.9027 11.6947 19 11.9307 19 12.208C19 12.486 18.9027 12.7223 18.708 12.917L17.5 14.125Z"
            fill="currentColor"
        />
    </svg>
);
DocPencilIcon.displayName = "DocPencilIcon";
